/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const hotelRating = async (): Promise<any> => {
  const rating = useJSONStore.getState().rating;
  const token = useUserStore.getState().userToken;
  const setRating = useJSONStore.getState().setRating;

  if (rating.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.rating}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setRating(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default hotelRating;
